import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "26",
  viewBox: "0 0 24 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22.3311 6.88574C22.8016 6.88579 23.1816 7.26578 23.1816 7.73633V8.8877C23.1815 9.35818 22.8016 9.73823 22.3311 9.73828H16.1387V24.6729C16.1387 25.1433 15.7595 25.5232 15.2891 25.5234H14.1182C13.6475 25.5234 13.2676 25.1435 13.2676 24.6729V18.0615H10.8516V24.6729C10.8516 25.1435 10.4716 25.5234 10.001 25.5234H8.85059C8.37996 25.5234 8 25.1435 8 24.6729V9.73828H1.66895C1.1984 9.73828 0.818482 9.35836 0.818359 8.8877V7.73633C0.818482 7.26578 1.1984 6.88579 1.66895 6.88574H22.3311ZM11.9961 0.476562C13.547 0.476682 14.8016 1.73132 14.8018 3.28223C14.8018 4.83313 13.5471 6.08777 11.9961 6.08789C10.4452 6.08777 9.19057 4.83313 9.19043 3.28223C9.19055 1.73132 10.4452 0.476682 11.9961 0.476562Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }